export default __webpack_public_path__ + "static/media/Escuela_de_Oracion_Home.ec055bcb.svg";